import { DEFAULT_OPTION, DEFAULT_SUB_ITEM } from '_utils/constant'
import { useFieldArray } from 'react-hook-form'
import DesktopInputProduct from './DesktopInputProduct'

const DesktopSubItem = ({
  control,
  register,
  nestIndex,
  productIndex,
  removeSubItem,
  insertSubItem,
  appendSubItem,
  subItem,
  watch,
  errors,
}) => {
  const baseName = `products.${productIndex}.subItems.${nestIndex}`
  const {
    fields,
    remove: removeOption,
    append: appendOption,
  } = useFieldArray({
    control,
    name: `${baseName}.list`,
  })

  const watchList = watch(`${baseName}.list`)
  const controlledFields =
    watchList?.length > 0 ? fields.map((field, i) => ({ ...field, ...watchList[i] })) : []

  const subErrors = errors?.products?.[productIndex]?.subItems?.[nestIndex]

  return (
    <div className='desktop-sub-item'>
      <div className='desktop-sub-item__header'>
        <div className='row align-items-center'>
          <div className='col-3 desktop-sub-item__label'>Sub item {nestIndex + 1}</div>
          <div className='col-9'>
            <DesktopInputProduct
              type='text'
              placeholder='Add Category'
              register={register(`${baseName}.type`)}
              error={subErrors?.type?.message}
              className={`form-control-bg ${subErrors?.type ? 'is-error-sub-item' : ''}`}
            />
          </div>
        </div>

        {controlledFields.map((_item, index) => (
          <div className='desktop-sub-item__option' key={index}>
            <div className='desktop-sub-item__option-name'>
              <span className='sub-txt'>{index + 1}. </span>
              <DesktopInputProduct
                type='text'
                placeholder='Name...'
                register={register(`${baseName}.list.${index}.name`)}
                error={subErrors?.list?.[index]?.name?.message}
                className={`form-control-line ${
                  subErrors?.list?.[index]?.name ? 'is-error-sub-item' : ''
                }`}
              />
            </div>
            <div className='desktop-sub-item__option-price'>
              <span className='sub-txt'>$ </span>
              <DesktopInputProduct
                type='number'
                step='0.01'
                placeholder='Price...'
                register={register(`${baseName}.list.${index}.price`)}
                error={subErrors?.list?.[index]?.price?.message}
                className={`form-control-line ${
                  subErrors?.list?.[index]?.price ? 'is-error-sub-item' : ''
                }`}
              />
            </div>
            <div className='mt-3 opacity-20' style={{ filter: 'grayscale(100%)' }}>
              <a className='btn-remove' onClick={() => removeOption(index)} />
            </div>
          </div>
        ))}

        <div className='row'>
          <div className='col-12 desktop-sub-item__add-option'>
            <a onClick={() => appendOption({ ...DEFAULT_OPTION })}>Add Option</a>
          </div>
        </div>
      </div>

      <div className='desktop-sub-item__footer'>
        <div className='desktop-sub-item__required'>
          <label className='required-label'>Required</label>
          <label className='switch'>
            <input type='checkbox' {...register(`${baseName}.required`)} />
            <span className='slider round'></span>
          </label>
        </div>
        <div className='desktop-sub-item__actions'>
          <a
            className='btn-add-01 cursor-pointer mr-1'
            title='Add sub-item'
            onClick={() => appendSubItem(JSON.parse(JSON.stringify({ ...DEFAULT_SUB_ITEM })))}
          />
          <a
            className='btn-copy cursor-pointer'
            title='Duplicate'
            onClick={() =>
              insertSubItem(parseInt(nestIndex + 1, 10), JSON.parse(JSON.stringify({ ...subItem })))
            }
          />
          <a
            className='btn-remove cursor-pointer'
            title='Remove'
            onClick={() => removeSubItem(nestIndex)}
          />
        </div>
      </div>
    </div>
  )
}

export default DesktopSubItem
